import { SET_SCRIPTS } from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.scripts, { type, payload }) {
  switch (type) {
    case SET_SCRIPTS:
      return payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/scripts/reducer.js